import type { GatsbyBrowser } from "gatsby";
import netlifyIdentity from "netlify-identity-widget";

if (typeof window !== "undefined") {
    netlifyIdentity.on("init", (user: any) => {
        if (!user) {
            netlifyIdentity.on("login", () => {
                document.location.href = "/admin/";
            });
        }
    });

    netlifyIdentity.init();
}

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {};
